import { createContext, useContext, useEffect, useState } from "react";
import { t as translate } from "@/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = window.localStorage.getItem("jk_lang");
    if (saved) return saved;
    const browser = (navigator.language || "en").slice(0, 2).toLowerCase();
    return ["es", "en", "de", "ru"].includes(browser) ? browser : "en";
  });

  useEffect(() => {
    window.localStorage.setItem("jk_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => translate(key, lang);
  const localized = (obj) => (obj && (obj[lang] || obj.en)) || "";

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, localized }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
  return ctx;
}
